import { render } from "./MaterialAlmacenList.vue?vue&type=template&id=7c8046e0&scoped=true"
import script from "./MaterialAlmacenList.vue?vue&type=script&lang=js"
export * from "./MaterialAlmacenList.vue?vue&type=script&lang=js"

import "./MaterialAlmacenList.vue?vue&type=style&index=0&id=7c8046e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8046e0"]])

export default __exports__